import { makeActionCreator } from '../../../core/types/redux';
import {
  RequestResultDetailsArgs,
  ResultDetailsActionConstants as C,
  SelectGroupTabArgs,
  SetResultDetailsArgs,
  RequestAttachListArgs,
  SetAttachListArgs,
  OpenAttachPopupArgs,
} from './types';

const create = makeActionCreator<C>();

export const initialize = create(C.INITIALIZE);
export const requestResultDetails = create<RequestResultDetailsArgs>(C.RESULT_DETAILS_REQUEST);
export const setResultDetails = create<SetResultDetailsArgs>(C.RESULT_DETAILS_SET);
export const selectGroupTab = create<SelectGroupTabArgs>(C.SELECT_GROUP_TAB_SET);
export const openTestListPopup = create(C.TEST_LIST_POPUP_OPEN);
export const closeTestListPopup = create(C.TEST_LIST_POPUP_CLOSE);
export const openAttachListPopup = create<OpenAttachPopupArgs>(C.ATTACH_LIST_POPUP_OPEN);
export const closeAttachListPopup = create(C.ATTACH_LIST_POPUP_CLOSE);
export const requestAttachList = create<RequestAttachListArgs>(C.ATTACH_LIST_REQUEST);
export const setAttachList = create<SetAttachListArgs>(C.ATTACH_LIST_SET);
